import { render, staticRenderFns } from "./VotesChartPage.vue?vue&type=template&id=47d4f402&scoped=true&"
import script from "./VotesChartPage.vue?vue&type=script&lang=js&"
export * from "./VotesChartPage.vue?vue&type=script&lang=js&"
import style0 from "./VotesChartPage.vue?vue&type=style&index=0&id=47d4f402&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47d4f402",
  null
  
)

export default component.exports